export default "__VITE_ASSET__c27af684__"